import React, { Component } from 'react';
import { Table, Popconfirm, message, Modal, Input, Button } from 'antd';
import DeptPendingModal from './DeptPendingModal';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';
import { connect } from 'react-redux';

class PendingDeptList extends Component {
    state = {
        searchParams: {},
        pagination: {
            pageSize: 10,
            current: 1,
        },
        data: [],
        loading: false,
    }

    componentDidMount() {
        this.loadData();
    }

    loadData = () => {
        const { pagination, searchParams } = this.state;
        const { current, pageSize } = pagination;
        this.setState({ loading: true });
        $.sendRequest({
            method: 'POST',
            url: API_URL.hospital.deptPendingCooperationList,
            data: {
                offset: current,
                limit: pageSize,
                ...searchParams,
            },
            dataType: 'json',
            doneResult: res => {
                if (!res.error) {
                    const datas = res.datas || [];
                    pagination.total = res.totalCount || datas.length;
                    this.setState({
                        pagination,
                        data: datas,
                        loading: false,
                    });
                } else {
                    this.setState({ loading: false });
                }
            },
            failResult: () => {
                this.setState({ loading: false });
            }
        });
    }

    handleSearchChange = (e, field) => {
        const { searchParams } = this.state;
        searchParams[field] = e.target ? e.target.value : e;
        this.setState({ searchParams });
    }

    handleSearch = () => {
        const { pagination } = this.state;
        this.setState({
            pagination: { ...pagination, current: 1 },
        }, () => {
            this.loadData();
        });
    }

    handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            this.handleSearch();
        }
    }

    showAdd = () => {
        this.deptPendingModalRef.show();
    }

    showEdit = (record) => {
        this.deptPendingModalRef.show(record);
    }

    handleDelete = (record) => {
        Modal.confirm({
            iconType: 'question-circle',
            title: "确定要删除吗？",
            onOk: () => {
                $.sendRequest({
                    method: 'POST',
                    url: API_URL.hospital.deptPendingCooperationDelete,
                    data: { hospitalDeptPendingCooperationId: record.hospitalDeptPendingCooperationId },
                    dataType: 'json',
                    doneResult: res => {
                        message.success('删除成功');
                        this.loadData();
                    },
                });
            },
        });
    }

    handleTableChange = (pagination) => {
        this.setState({ pagination }, () => {
            this.loadData();
        });
    }

    getColumns = () => {
        const { menuAuth = {} } = this.props;
        const positionRole = sessionStorage.positionRole;
        const hasPendingPermission = positionRole === 'CRCC' || positionRole === 'CRCM' || positionRole === 'PML' || !!menuAuth.areaChargeUser || sessionStorage.isClinicalBO === 'true';

        const columns = [{
            title: '序号',
            dataIndex: 'index',
            key: 'index',
            width: 60,
        }, {
            title: '医院',
            dataIndex: 'hospitalName',
            key: 'hospitalName',
            width: 200,
        }, {
            title: '院区',
            dataIndex: 'courtyardArea',
            key: 'courtyardArea',
            width: 100,
        }, {
            title: '科室',
            dataIndex: 'deptName',
            key: 'deptName',
            width: 150,
        }, {
            title: '备注',
            dataIndex: 'remark',
            key: 'remark',
            width: 150,
        }];

        if (hasPendingPermission) {
            columns.push({
                title: '操作',
                dataIndex: 'option',
                key: 'option',
                width: 150,
                render: (text, record) => (
                    <span>
                        <a onClick={() => this.showEdit(record)}>修改</a>
                        <span className="ant-divider" />
                        <Popconfirm title="确定删除该待合作科室？" onConfirm={() => this.handleDelete(record)} okText="确定" cancelText="取消">
                            <a>删除</a>
                        </Popconfirm>
                    </span>
                ),
            });
        }

        return columns;
    }

    render() {
        const { loading, pagination, searchParams, data } = this.state;
        return (
            <div>
                <div style={{ marginBottom: 16 }}>
                    <div className="search-bar" style={{ marginBottom: 8 }}>
                        <div className="search-item">
                            <label className="ui-label">医院官方名称</label>
                            <Input
                                style={{ width: 200 }}
                                placeholder="请输入"
                                value={searchParams.hospitalName || ''}
                                onChange={e => this.handleSearchChange(e, 'hospitalName')}
                                onKeyDown={this.handleKeyDown}
                            />
                        </div>
                        <div className="search-item">
                            <label className="ui-label">院区</label>
                            <Input
                                style={{ width: 150 }}
                                placeholder="请输入"
                                value={searchParams.courtyardArea || ''}
                                onChange={e => this.handleSearchChange(e, 'courtyardArea')}
                                onKeyDown={this.handleKeyDown}
                            />
                        </div>
                        <div className="search-item">
                            <label className="ui-label">科室</label>
                            <Input
                                style={{ width: 150 }}
                                placeholder="请输入"
                                value={searchParams.deptName || ''}
                                onChange={e => this.handleSearchChange(e, 'deptName')}
                                onKeyDown={this.handleKeyDown}
                            />
                        </div>
                        <div className="search-item">
                            <Button type="primary" onClick={this.handleSearch}>搜索</Button>
                            {(sessionStorage.positionRole === 'CRCC' || sessionStorage.positionRole === 'CRCM' || !!this.props.menuAuth.areaChargeUser || sessionStorage.positionRole === 'PML' || sessionStorage.isClinicalBO === 'true') &&
                                <Button type="primary" style={{ marginLeft: 8 }}
                                    onClick={this.showAdd}>新增</Button>
                            }
                        </div>
                    </div>
                </div>
                <Table
                    columns={this.getColumns()}
                    dataSource={(data || []).map((item, index) => ({
                        ...item,
                        index: (pagination.current - 1) * pagination.pageSize + index + 1,
                    }))}
                    rowKey={record => record.index || record.hospitalDeptPendingCooperationId}
                    loading={loading}
                    scroll={{ x: 800 }}
                    onChange={this.handleTableChange}
                    pagination={pagination}
                    className="hospitalTableStyle"
                />
                <DeptPendingModal ref={el => this.deptPendingModalRef = el} loadData={this.loadData} />
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return { menuAuth: state.menuState.menuAuth || {} };
};

export default connect(mapStateToProps)(PendingDeptList);


// WEBPACK FOOTER //
// ./src/components/hospital/departmentInfo/PendingDeptList.js